<div *ngIf="userProfile$ | async as userProfile" class="focus-border">

  <button class="btn" [matMenuTriggerFor]="menu" i18n-aria-label="topnav user menu@@topnav-user-menu" aria-label="User menu" (menuOpened)="menuOpened($event)">
    <ng-container *ngIf="getPictureUrl(userProfile) | async as src;else letters">
      <div class="user-image user-image-bg bg-subtle-color align-self-center rounded-circle" [ngStyle]="{'background-image': 'url(' + src + ')'}" data-hj-suppress></div>
      <div class="ml-2 user-image-chevron"><i class="ms-Icon ms-Icon--ChevronDown align-middle" aria-hidden="true"></i></div>
    </ng-container>
    <ng-template #letters>
      <div class="user-image bg-subtle-color letters align-self-center rounded-circle position-relative d-inline-block align-middle" data-hj-suppress title="{{userProfile.displayName}}">
        <span class="mb-0 letters-text">{{ getPreferredNameLetters(userProfile) }}</span>
      </div>
      <i class="ml-2 ms-Icon ms-Icon--ChevronDown align-middle" aria-hidden="true"></i>
    </ng-template>
  </button>

  <mat-menu #menu="matMenu" role="menu" [yPosition]="'below'" [xPosition]="'before'" [overlapTrigger]="'false'" class="user-menu-list">
    <ng-container *ngIf="hasPermissionEditorOrAdmin$ | async as hasPermission">
      <ng-container *ngSubscribe="editModeInfoBoxes$ as editMode">
        <ng-container *ngIf="anyInfoBoxesOnPage">
          <button id="btn-infobox" mat-menu-item (keyup.arrowright)="showInfoBoxZones($event)" (keyup.arrowleft)="showInfoBoxZones($event)">
          <mat-slide-toggle title="Edit infoboxes"
                            i18n-title="@@edit-infoboxes"
                            i18n-aria-label="@@edit-infoboxes"
                            aria-label="Edit infoboxes"
                            [checked]="editMode"
                            (change)="showInfoBoxZones($event)"
                            (keyup.arrowright)="showInfoBoxZones($event)"
                            (keyup.arrowleft)="showInfoBoxZones($event)"
                            i18n="@@edit-infoboxes">Edit infoboxes</mat-slide-toggle>
            </button>
        </ng-container>
        <hr *ngIf="anyInfoBoxesOnPage" class="my-0"/>
      </ng-container>
    </ng-container>

    <button mat-menu-item routerLink="/settings" class="menu-button" i18n="settings link help and settings@@settings-link-help-and-settings">Settings</button>

      <ng-container *appFeatureToggle="'showGoToDelveOnUserMenu'">
        <button mat-menu-item (click)="goToDelve(userProfile)" class="menu-button" i18n="@@user-menu-delve-link">My Office profile</button>
      </ng-container>

    <ng-container *ngIf="hasPermissionEditorOrAdminOrDashBoard$ | async as hasPermission">
      <button mat-menu-item *ngIf="hasPermission" routerLink="/editor-dashboard" class="menu-button" i18n="editor dashboard@@editor-dashboard">Editor dashboard</button>
    </ng-container>

    <ng-container *ngIf="hasPermissionAdmin$ | async as hasPermission">
      <button mat-menu-item *ngIf="hasPermission" routerLink="/admin" class="menu-button" i18n="admin dashboard@@admin-dashboard">Admin dashboard</button>
    </ng-container>

    <button mat-menu-item *ngIf="enableMyProfile" [routerLink]="['/user/detail', userUpn]" class="menu-button" i18n="my profile@@my-profile">My profile</button>

    <button mat-menu-item class="menu-button" (click)="logOut()" i18n="user menu signout button@@user-menu-signout-button">Sign out</button>

  </mat-menu>
</div>
